'use client'

import ToggleBox from '@component/toggleBox'
import IconFloorplan from '@icon/house/floorplan.svg'
import IconLandarea from '@icon/house/landarea.svg'
import { joinStr } from '@utils'
import { isVillageData, isOfflineData, isProjectData, isVillageTypeUnitData } from '@utils/house'
import classNames from 'classnames'
import { get, replace } from 'lodash-es'

export default function HouseDesc({
  data,
  children
}) {

  const address = joinStr([get(data, 'street'), get(data, 'suburb'), get(data, 'district')])
  const price = data.isComingSoon ? 'Coming Soon' : joinStr([get(data, 'priceBold'), get(data, 'priceLight')])

  const isVillage = isVillageData(data)
  const isVillageUnit = isVillageTypeUnitData(data)
  const isOffline = isOfflineData(data)
  const isProject = isProjectData(data)
  return (
    <div>
      {
        isVillage && !isVillageUnit
          ? (
            <>
              {/* {data.brief && <em className='text-font text-xs mb-8 not-italic'>{data.brief}</em>} */}
              {data.teaser && <div className='text-font text-3xl font-bold mb-8'>{data.teaser}</div>}
              <div className='text-font text-xl'>{address}</div>
            </>
          )
          : (
            <>
              {
                isOffline
                  ? <h1 className='hidden'>{address}</h1>
                  : <h1 className='text-font text-3xl font-bold not-italic text-black'>{address}</h1>
              }
              <div className='text-font text-2xl mt-8 text-black'>{price}</div>
              <div className='flex mt-8 space-x-16 sm:space-x-24'>
                <FacilityItem num={data.bedrooms} icon='icon-bed'></FacilityItem>
                <FacilityItem num={data.bathrooms} icon='icon-bath'></FacilityItem>
                <FacilityItem num={data.carspaces} icon='icon-car'></FacilityItem>
                <FacilityItem
                  num={!isProject ? data.floorArea : 0}
                  svg={<IconFloorplan width={20} height={20} fill='var(--color-ref-neutral5)'></IconFloorplan>}
                  html={data.floorAreaString}
                ></FacilityItem>
                <FacilityItem
                  num={data.landArea}
                  svg={<IconLandarea width={20} height={20} fill='var(--color-ref-neutral5)'></IconLandarea>}
                  html={data.landAreaString}
                ></FacilityItem>
              </div>
              {data.teaser && <div className='text-black text-xl mt-24'>{data.teaser}</div>}
            </>
          )
      }
      <ToggleBox height={200} className='mt-8' showAllLabel={<button className='button-text-primary'>Read more <i className='icon icon-arrow-down !text-sm'></i></button>}>
        <div className='childs-[p+p]:mt-10 childs-[a]:text-primary child-[ul]:list-disc child-[ol]:list-item' dangerouslySetInnerHTML={{ __html: getDescription(data) }}></div>
        {children}
      </ToggleBox>
    </div>
  )
}

function getDescription(data) {
  const text = get(data, 'description', '') || ''
  return replace(text, /\r?\n/g, '<br/>')
}

function FacilityItem({
  children,
  svg,
  icon,
  num,
  html
}) {

  return num > 0 && (
    <div className='flex items-center text-neutral-5'>
      {
        svg
          ? svg
          : <i className={classNames('icon !text-xl !sm:text-2xl', icon)}></i>
      }
      {
        html
          ? <span className='ml-8 text-base' dangerouslySetInnerHTML={{ __html: html || '' }}></span>
          : <span className='ml-8 text-base'>{children || num}</span>
      }

    </div>
  )
}